/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HolderLastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function HolderLastName({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Card/HolderLastName",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentCreditCardHolderLastNameValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'credit_card.holder_last_name',
})
let paymentCreditCardHolderLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payment',
path: 'credit_card.holder_last_name',
validate: fromValidate.name,
required: true,
})
let paymentCreditCardHolderLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'payment',
path: 'credit_card.holder_last_name',
})
let paymentCreditCardHolderLastNameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="payment.credit_card.holder_last_name"
 validate="/Data/validate.js name"
 required={true}
 value={paymentCreditCardHolderLastNameValueData}
 onChange={paymentCreditCardHolderLastNameChangeData}
 invalid={!paymentCreditCardHolderLastNameIsValidData}
 invalidMessage="Please input card holder's last name"
 disabled={paymentCreditCardHolderLastNameIsSubmittingData}
 marginTop={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="Card holder's last name"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}